import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SpinoffAuthService } from '@sbe-spinoff-client/spinoff-platform';
import { LegacyHandoffService } from './legacy-handoff.service';
import { OrgContextService } from './org-context.service';

// app-shell/consent-list 두 로그아웃 진입점이 동일한 순서로 호출해야 하는 로직 — 한쪽만 고치면
// 재발하는 버그(2026-07-07, 서버 refresh token 미폐기로 로그아웃 후 새로고침 시 세션이 되살아남)를
// 겪은 뒤 단일 구현으로 모았다. 서버 refresh token 폐기 + 클라이언트 세션 정리는 2026-08-17부터
// SpinoffAuthService.signOut()이 담당한다(spinoff-auth-pattern-alignment 플랜 PR3).
@Injectable({ providedIn: 'root' })
export class LogoutService {
  private readonly auth = inject(SpinoffAuthService);
  private readonly orgContext = inject(OrgContextService);
  private readonly legacyHandoff = inject(LegacyHandoffService);
  private readonly router = inject(Router);

  // returnUrl: 로그아웃 후 이동할 /login의 return 쿼리(예: authorize 화면의 계정 전환 —
  // 다른 계정으로 다시 로그인한 뒤 진행 중이던 interaction으로 돌아가야 한다). 생략하면 기존과
  // 동일하게 그냥 /login으로 이동한다.
  async logout(returnUrl?: string): Promise<void> {
    // signOut()이 서버 refresh token 폐기(sbe_spinoff_refresh 쿠키 삭제 응답 대기) +
    // 클라이언트 access token 정리를 함께 한다 — best-effort 내부 처리는 서비스 쪽 책임.
    await this.auth.signOut();
    // root-singleton OrgContextService 캐시를 초기화 — 새로고침 없이 다른 사용자가 로그인하면
    // 이전 사용자의 org 목록·선택 상태가 남아 있는 문제(2026-07-06 코드 리뷰) 방지.
    this.orgContext.reset();
    // v4의 이 브라우저 로그인 흔적도 지운다 — best-effort, 실패해도 신규 앱 로그아웃은 그대로 진행.
    void this.legacyHandoff.notifyLogout();
    void this.router.navigate(['/login'], returnUrl ? { queryParams: { return: returnUrl } } : {});
  }
}
